import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Ec2 } from "../models/ec2";
import { ResourceService } from "../../../core/services/resource.service";
import { map, Observable, from, of } from "rxjs";
import { shareReplay, take, filter, switchMap } from "rxjs/operators";
import { AppConfigService } from "src/app/app-config.service";
import { MatDialog } from "@angular/material/dialog";
import {
  ConfirmDialogConfig,
  ConfirmDialogComponent,
} from "../components/confirm-dialog/confirm-dialog.component";
import { AlertDialog, AlertDialogConfig } from "../components/alert/dialog";

@Injectable({ providedIn: "root" })
export class Ec2Service extends ResourceService<Ec2> {
  constructor(
    private readonly dialog_: MatDialog,
    private http: HttpClient,
    private configService: AppConfigService,
  ) {
    super(http, Ec2, "ec2");
  }

  public start(object: any): Observable<any> {
    console.log(" Object to start : ", object);
    const config = {
      title: "Confirmer le démarrage de la ressource",
      message:
        "Souhaitez-vous confirmer le démarrage de la ressource " +
        object.name +
        " (" +
        object.instanceId +
        ") ?",
    } as ConfirmDialogConfig;

    return this.dialog_
      .open(ConfirmDialogComponent, { data: config })
      .afterClosed()
      .pipe(
        filter((result) => result),
        switchMap((_) => {
          return from(
            this.api.put("route-api", `ec2/${object.instanceId}/start`, {
              body: {
                ownerId: object.OwnerId,
                region: object.region,
              },
            })
          ).pipe(
            map((response) => {
              if (!response.status) {
                const config = {
                  title: "Erreur",
                  message:
                    "Une erreur est survenue lors du démarrage de la ressource : " +
                    object.name +
                    " (" +
                    object.instanceId +
                    "). " +
                    response.message,
                  confirmLabel: "OK",
                } as AlertDialogConfig;
                this.dialog_.open(AlertDialog, { data: config });
                throw new Error(response.message);
              } else {
                const config = {
                  title: "Démarrage en cours",
                  message: `L'instance ${object.name || object.instanceId} (${object.instanceId}) démarre. Son état est suivi dans la colonne État.`,
                  confirmLabel: "OK",
                } as AlertDialogConfig;
                this.dialog_.open(AlertDialog, { data: config });
                return response;
              }
            })
          );
        })
      );
  }

  public stop(object: any): Observable<any> {
    console.log(" Object to stop : ", object);
    const config = {
      title: "Confirmer l'arrêt de la ressource",
      message:
        "Souhaitez-vous confirmer l'arrêt de la ressource " +
        object.name +
        " (" +
        object.instanceId +
        ") ?",
    } as ConfirmDialogConfig;

    return this.dialog_
      .open(ConfirmDialogComponent, { data: config })
      .afterClosed()
      .pipe(
        filter((result) => result),
        switchMap((_) => {
          return from(
            this.api.put("route-api", `ec2/${object.instanceId}/stop`, {
              body: {
                ownerId: object.OwnerId,
                region: object.region,
              },
            })
          ).pipe(
            map((response) => {
              if (!response.status) {
                const config = {
                  title: "Erreur",
                  message:
                    "Une erreur est survenue lors de l'arrêt de la ressource : " +
                    object.name +
                    " (" +
                    object.instanceId +
                    "). " +
                    response.message,
                  confirmLabel: "OK",
                } as AlertDialogConfig;
                this.dialog_.open(AlertDialog, { data: config });
                throw new Error(response.message);
              } else {
                const config = {
                  title: "Arrêt en cours",
                  message: `L'instance ${object.name || object.instanceId} (${object.instanceId}) s'arrête. Son état est suivi dans la colonne État.`,
                  confirmLabel: "OK",
                } as AlertDialogConfig;
                this.dialog_.open(AlertDialog, { data: config });
                return response;
              }
            })
          );
        })
      );
  }

  public getByGroup(group_id: string): Observable<Ec2[]> {
    return from(
      this.api.get("route-api", `${this.apiUrl}?group=${group_id}`, {}),
    ).pipe<any>(map((result) => result.resource));
  }
}